export default __webpack_public_path__ + "static/media/heart.6a722d2f.png";